import { Button } from 'antd-v5';
import { Link } from 'react-router-dom';

export const Section = ({ title, viewAllUrl, children, className = '', actions }) => {
  return (
    <div className={`flex-col ${className}`}>
      <div className="flex-row items-center justify-between m-btm-10">
        <span className="fs-15 fw-500">{title}</span>
        {actions ? (
          <div className="flex-row items-center m-right-15">{actions}</div>
        ) : (
          viewAllUrl && (
            <Link to={viewAllUrl}>
              <Button type="link" className="cb-link-btn">
                View All
              </Button>
            </Link>
          )
        )}
      </div>
      <div className="m-top-10 w-100-P">{children}</div>
    </div>
  );
};
